import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import { get } from "lodash";

const SectionNewsTagBase = ({ items, pagetype }) => {
  if (!items || pagetype !== "section-page") {
    return null;
  }
  let arr = [];
  items
    .slice(0, 16)
    .filter(late => late.type === "story")
    .map(late => {
      const name = get(late, ["story", "tags", 0, "name"], null);
      const Url = get(late, ["story", "url"], null);
      if (name) {
        arr.push({ name: name, url: Url });
      }
    });
  const key = "name";
  const arrayUniqueByKey = [...new Map(arr.map(item => [item[key], item])).values()];
  if (!arr) {
    return null;
  }
  console.log("arrayUniqueByKey111---------------", arrayUniqueByKey);
  if (pagetype === "section-page") {
    return (
      <div>
        <h5 className={styles["footer-title"]}>
          <span>VIKATAN NEWS</span>
        </h5>
        <div className={styles["ul-grid"]}>
          <ul className={styles["latest-list"]}>
            {arrayUniqueByKey.map(late => (
              <li key={late.id} className={styles["li-list"]}>
                <Link href={`${late.url}`}>{late.name}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div />
      </div>
    );
  } else {
    return null;
  }
};
const SectionNewsTag = connect(state => {
  return {
    qt: get(state, ["qt"]),
    collection: get(state, ["qt", "data", "collection"]),
    items: get(state, ["qt", "data", "collection", "items"]),
    pagetype: get(state, ["qt", "pageType"])
  };
})(SectionNewsTagBase);

SectionNewsTag.propTypes = {
  latestIssues: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      slug: PropTypes.string,
      metadata: PropTypes.shape({
        "cover-image": PropTypes.shape({
          "cover-image-metadata": PropTypes.shape({
            height: PropTypes.number,
            width: PropTypes.number
          }),
          "cover-image-s3-key": PropTypes.string
        }),
        magazine: PropTypes.shape({
          name: PropTypes.string
        })
      })
    })
  )
};

SectionNewsTagBase.propTypes = {
  ...SectionNewsTag.propTypes,
  data: PropTypes.shape({
    collection: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string
      })
    ),
    magazines: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        magazineSlug: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
        vikatanMagazineId: PropTypes.number
      })
    )
  }),
  className: PropTypes.string
};

export default SectionNewsTag;
